import { toast } from 'react-toastify';

const TOAST_OPTIONS = {
    position: 'top-center',
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    toastId: 'session-expired-toast',
};

let isRedirecting = false;

/**
 * Handles API exception responses.
 * If the response indicates an unauthenticated session, clears storage and redirects to login.
 * NOTE: The `exception_type` value "unthenticated" is a backend typo — kept as-is for compatibility.
 */
export function HandleExeption(data, isLogoutRequest = false) {
    if (
        data &&
        typeof data === 'object' &&
        data.hasOwnProperty('exception_type') &&
        (data.exception_type === 'unthenticated' || data.exception_type === 'unauthenticated')
    ) {
        const tokenName = process.env.REACT_APP_BACKEND_TOKEN_NAME || 'user-token';
        localStorage.removeItem(tokenName);
        localStorage.removeItem('permissions');

        // Do not show "session expired" warning or trigger reload if this was an intentional logout
        // or if the user is already on auth pages (login/register)
        const isAuthPage = window.location.pathname === '/login' || window.location.pathname === '/register';

        if (!isLogoutRequest && !isAuthPage && !isRedirecting) {
            isRedirecting = true;
            if (!toast.isActive('session-expired-toast')) {
                toast.warn(
                    'Your login session has expired. Please log in again.',
                    TOAST_OPTIONS
                );
            }
            setTimeout(() => {
                isRedirecting = false;
                window.location.replace('/login');
            }, 1500);
        }
    }
}

export function RaiseSomethingWentWrong() {
    if (!toast.isActive('something-went-wrong-toast')) {
        toast.error('Something Went Wrong!', {
            ...TOAST_OPTIONS,
            toastId: 'something-went-wrong-toast',
        });
    }
}

